export default __webpack_public_path__ + "static/media/placa-electronica.eb83d966.png";